export class NotValidJsonStringError extends Error {
    constructor() {
        super("Not a valid JSON string");
        Object.setPrototypeOf(this, NotValidJsonStringError.prototype);
    }
}